import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { AddressContainer } from '../../../../../common/address/containers/address.container';
import OneUserBasicInfoComponent from './one-user-basic-info.component';
import OneUserAccountInfoComponent from './one-user-account-info.componenet';
import OneUserProfileInfoComponent from './one-user-profile-info.component';
import OneUserAddressComponent from './one-user-primary-address-info.component';

export const OneUserComponent = ({handleBasicInnerFormChange, basicHandleTags,handleInnerFormChange,id,selectedOneUser,back,accounts,handleFormSubmit,tagNames,tags,}: any) => {
  const tabItems=[
    {
        id:1,
        title:'ONE User Details',
        component:<OneUserBasicInfoComponent 
        handleBasicFormChange={handleBasicInnerFormChange}
        handleInnerFormChange={handleInnerFormChange}
        basicHandleTags={basicHandleTags}
        selectedOneUser={selectedOneUser}
        id={id}
        tagNames={tagNames}
        tags={tags}
       />,
    isVisible:true,
    },
    {
      id:2,
      title:'Account Info',
      component:<OneUserAccountInfoComponent 
      handleInnerFormChange={handleInnerFormChange}
      selectedOneUser={selectedOneUser}
      accounts={accounts}
     />,
  isVisible:true,
  },
    {
        id:3,
        title:'User Profile',
        component:<OneUserProfileInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedOneUser={selectedOneUser}
       />,
    isVisible:true,
    },
    {
      id: 4,
      title: 'Address',
      component: <OneUserAddressComponent
        onInnerFormChange={handleInnerFormChange}
        selectedAddress={selectedOneUser}
      />,
      isVisible: true,
    },
   

  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default OneUserComponent;
